<template>
  <skeleton :button="buttonLabel" @next="$emit('next')" :image="background">
    <vv-speech-bubble :title="leftTitle" :subtitle="rightTitle">
      {{ text }}
    </vv-speech-bubble>
  </skeleton>
</template>

<script>
import { VvSpeechBubble } from '@/components/common'
import Skeleton from './TransitionSkeleton'

export default {
  name: 'SpeechTransition',
  components: { VvSpeechBubble, Skeleton },
  props: {
    buttonLabel: String,
    leftTitle: String,
    rightTitle: String,
    text: String,
    background: String
  }
}
</script>
